<template>
	<v-layout row wrap align-center class="app-subheader">
		<v-flex xs12 class="app-subheader-container">
			<slot></slot>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: 'app-subheader',
	};
</script>

<style lang="scss" scoped>
	.app-subheader {
		background-color: color(white);
		box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.08);
		min-height: 84px;

		&-container {
			margin: 0 auto;
			max-width: 1200px;
			padding: 0 15px 18px;

			@media (min-width: 936px) {
				padding: 0 15px;
			}

			@media (min-width: 1280px) {
				padding: 0px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/app-subheader.vue